import { useTranslation } from 'react-i18next';
import { Navbar } from '@/components/Navbar';
import { PublicFooter } from './PublicFooter';
import { cn } from '@/lib/utils';

export const PublicShell = ({ children, className, testId = 'public-shell' }) => {
  const { t } = useTranslation();
  return <div className={cn('product-ui public-shell', className)} data-testid={testId}>
    <a href="#main-content" className="skip-nav-link" data-testid="public-skip-link">{t('homepage.skip')}</a>
    <Navbar />
    {children}
    <PublicFooter />
  </div>;
};